import React from 'react';
import css from './styles.module.css';

export default function Tab({
  className = '',
  classNameActive = '',
  isActive,
  onClick,
  children,
}) {
  return (
    <button
      className={`${css.tabButton} ${
        isActive ? `${css.active} ${classNameActive}` : ''
      } ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
